import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.board.item');
import { OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import moment from "moment";
import showdown from 'showdown';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-gsdcuser-board-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.board.item/view.scss */
/* src/app/portal.gsdcuser.board.item/view.scss: no such file or directory */`],
})
export class PortalGsdcuserBoardItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() board_id: any;
    @Input() category: any;

    @ViewChild('editor')
    public editorElement: ElementRef;
    public comments: any = [];
    public comment_text: any = '';
    public commentFiles: any = [];

    public board: any = {};
    public editor: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/");
        await this.load();
        await this.buildEditor();
        await this.service.loading.hide();
    }

    public async load() {
        if (this.board_id != 'new') {
            const { code, data } = await wiz.call("get", { id: this.board_id });
            if (code != 200) return await this.service.alert.error("Error!");

            this.board = data.item;
            this.board.extra = JSON.parse(this.board.extra.replace(/'/g, '"'));
            this.comments = data.comments;
            // this.board.created = moment(this.board.created).format("YYYY-MM-DD");
            // this.board.updated = moment(this.board.updated).format("YYYY-MM-DD");
        } else {
            this.board = {
                title: '',
                content: '',
                extra: [],
                created: moment().format("YYYY-MM-DD")
            };
        }

        await this.service.render();
    }

    public async buildEditor() {
        let editor = this.editor = await ClassicEditor.create(document.querySelector("textarea#editor"), {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.data.set(this.board.content);

        await this.service.render();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async update() {
        if (this.board.title == "") return await this.service.alert.error("제목을 입력해주세요.");
        if (this.tab == 'text') this.changeTab('editor')
        this.board.content = this.editor.data.get();
        let data: any = JSON.stringify(this.board);
        const { code } = await wiz.call("update", { data: data });
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success('저장되었습니다');

        if (!this.board.id) {
            this.router.navigateByUrl('/admin/board');
        }
    }

    public tab = "editor";
    public changeTab(tab) {
        if (tab === "editor") {
            this.editor.data.set(this.board.content);
        }
        this.tab = tab;
        this.service.render();
    }

    public async delete() {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("delete", { id: this.board.id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.router.navigateByUrl('/admin/board');
    }

    public fd = new FormData();
    public async fileUpload(e) {
        if (!this.board.extra) this.board.extra = [];
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            this.filename = file.name;
            if (!file.filepath) file.filepath = file.name;
            this.fd.append('upload', file);
            let fdurl = '/file/upload';
            const { url } = await this.service.file.upload(fdurl, this.fd, async (percent: number, total: number, position: number) => { });
            let fileInfo = { name: file.name, size: file.size, url: url }
            this.board.extra.push(fileInfo);
        }
        await this.service.render();
    }

    public async removeAttachment(index: number) {
        this.board.extra = this.board.extra.filter((_, i) => i !== index);
        await this.service.render();
    }

    public async removeFile(file) {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        this.board.extra.remove(file);
        this.service.render();
    }

    public async commentWrite(comment: any) {
        if (!comment) return await this.service.alert.warning("댓글을 작성해주세요.");
        this.newComment = comment;
        const { code, data } = await wiz.call("commentWrite", { board_id: this.board_id, comment: this.newComment });
        if (code != 200) return await this.service.alert.error("Error!");
        this.newComment = "";
        await this.load();
    }

    public async removeComment(comment) {
        let res = await this.service.alert.error("댓글을 삭제하시겠습니까?", "닫기", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove_comment", comment);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.load();
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }

}

export default PortalGsdcuserBoardItemComponent;